module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "panel-fade",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut"
    }
  }, [_c('div', {
    staticClass: "panel-wrapper"
  }, [_c('div', {
    staticClass: "header",
    style: ({
      backgroundColor: _vm.cssPropColor('$color-primary')
    })
  }, [_c('span', {
    staticClass: "label",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "inner",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-731e375c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileContentTerms.vue
// module id = 467
// module chunks = 1